import Navbar from "../includes/navbar";

function NotFound() {
    return (
        <>
            <Navbar activePage="#" />
            <div className="not-found-page">
                Error 404: Page not Found!
            </div>
        </>
    );
}

export default NotFound;